window.Vue = require('vue');

Vue.component('appointment-summary', require('./components/AppointmentSummary'));
Vue.component('modal', require('./components/Modal'));
Vue.component('people-counter', require('./components/PeopleCounter'));

let appointmentSummary = new Vue({
    el: '#appointment-summary'
});

let fitVids = require('fitvids');

(function ($) {
    "use strict";

    $('#portal-navigation-button').on('click', function (event) {
        event.preventDefault();

        $(this).toggleClass('active');

        $('.portal-navigation').toggleClass('is-open');
    });

    $('.portal-header-primary-group-search form').on('submit', function (event) {
        var $logo = $('.portal-header-primary-logo');
        var $form = $(this);
        var $formContainer = $form.parent();
        var $input = $form.find('.form-control');
        var $button = $(this).find('#portal-search-button');

        // Hide search input on mobile screens
        if (window.matchMedia("(max-width: 959px)").matches) {
            // If search input contains string
            if ($button.hasClass('active') && $input.val().trim().length > 0) {
                // Submit

            // If search input is empty but visible
            } else if ($button.hasClass('active')) {
                event.preventDefault();

                $logo.attr('hidden', false);
                $formContainer.removeClass('flex-grow-1');
                $form.removeClass('flex-grow-1');
                $input.hide();
                $input.removeClass('flex-grow-1');
                $button.removeClass('active');

                // If search input is not even visible
            } else {
                event.preventDefault();

                $logo.attr('hidden', true);
                $formContainer.addClass('flex-grow-1');
                $form.addClass('flex-grow-1');
                $input.addClass('flex-grow-1');
                $input.show();
                $input.focus();
                $button.addClass('active');
            }

        // Display search input if hidden on desktop
        } else {
            if ($button.hasClass('active')) {
                $('.portal-header-primary-group-contact').attr('hidden', false);
                $('.portal-header-primary-group-profile').attr('hidden', false);
            }
            if ($input.val().trim().length === 0) {
                event.preventDefault();

                $logo.attr('hidden', false);
                $formContainer.removeClass('flex-grow-1');
                $form.removeClass('flex-grow-1');
                $input.show();
                $input.focus();
                $input.removeClass('flex-grow-1');
                $button.removeClass('active');
            }
        }
    });

    $(window).on('resize', function (event) {
        var headerHeight = $('.portal-header').outerHeight();

        var $button = $('#portal-search-button');
        var $logo = $('.portal-header-primary-logo');
        var $form = $button.closest('form');
        var $formContainer = $form.parent();
        var $input = $form.find('.form-control');

        if (window.matchMedia("(max-width: 960px)").matches) {
            if (!$button.hasClass('active')) {
                $formContainer.removeClass('flex-grow-1');
                $form.removeClass('flex-grow-1');
                $logo.attr('hidden', false);
                $input.hide();
                $input.removeClass('flex-grow-1');
            } else {
                $('.portal-header-primary-group-contact').attr('hidden', true);
                $('.portal-header-primary-group-profile').attr('hidden', true);
            }
            //$button.removeClass('active');
        } else {
            $input.show();
        }

        // Check if homepage carousel is present on the page and is not empty
        if ($('.homepage-carousel .carousel-item').length) {
            $('.portal-header-primary').addClass('is-open');
            $(document.body).css('margin-top', 0);

            var delay = 100;
            var timeout = null;

            $(window).on('scroll', function (event) {
                clearTimeout(timeout);
                timeout = setTimeout(function () {
                    if ($(window).scrollTop() !== 0) {
                        $('.portal-header-primary').removeClass('is-open');
                    } else {
                        $('.portal-header-primary').addClass('is-open');
                    }
                }, delay);
            });

        } else if ($('.portal-header').length) {
            $(document.body).css('margin-top', headerHeight + 60);
        }

        // Check if news hero image is present on the page
        if ($('.hero-image-news').length) {
            $(document.body).css('margin-top', headerHeight);
        }
    }).resize();

    fitVids('.video-container');
    fitVids('.map-container', { players: "iframe[src*='maps.google.com']" });
})(jQuery);




// WEBPACK FOOTER //
// ./resources/assets/js/app.js